<template>
  <qx-card title="列表">
    <ChooseRole
      ref="chooseRole"
      @change="handleRoleChange"
      :customShow="true"
    />
    <LogRightDialog ref="logRightDialog" busiCode="100005" />
    <section slot="titleRight">
      <qx-permpisions permpisions="1100101">
        <el-button type="primary" plain @click="() => toEdit()">
          <i class="iconfont">&#xe6ab;</i>新增
        </el-button>
      </qx-permpisions>

      <qx-permpisions permpisions>
        <TableSetting v-model="tableData.title" />
      </qx-permpisions>
    </section>
    <section class="tablePage">
      <!-- 表格 -->
      <section class="tableBox" ref="tableBox">
        <el-table
          v-loading="tableData.loading"
          ref="multipleTable"
          :data="tableData.data"
          tooltip-effect="dark"
          :height="tableHeight"
          @select="handleSelectionChange"
          @select-all="handleSelectionChange"
        >
          <!-- 选择框 -->
          <!-- <el-table-column type="selection" width="55" /> -->
          <!-- 选择框 end -->
          <!-- 常规列表项 -->
          <template v-for="(item, index, key) in tableData.title">
            <el-table-column
              :key="key"
              :prop="item.prop"
              :label="item.label"
              :sortable="item.sortable"
              :filters="item.filters"
              :filter-method="item.filterHandler"
              :min-width="item.minW"
              :width="item.w"
              :fixed="item.fixed"
              v-if="item.show"
            >
              <section slot-scope="scope">
                <section
                  v-if="scope.column.property === 'loginAcct'"
                  @click="toDetail(scope.row)"
                >
                  <span class="primary cur">
                    {{ scope.row[scope.column.property] }}
                  </span>
                </section>
                <section
                  v-else-if="scope.column.property === 'bankBindStateName'"
                >
                  <template v-if="checkPermpisions('1100106')">
                    <span class="primary cur" @click="toBankcard(scope.row)">
                      {{ scope.row[scope.column.property] }}
                    </span>
                  </template>
                  <template v-else>
                    <span>
                      {{ scope.row[scope.column.property] }}
                    </span>
                  </template>
                </section>
                <section v-else>{{ scope.row[scope.column.property] }}</section>
              </section>
            </el-table-column>
          </template>
          <!-- 常规列表项 end -->
          <!-- 操作按钮 -->
          <el-table-column
            prop="control"
            label="操作"
            width="140"
            fixed="right"
          >
            <template slot-scope="scope">
              <TableBtn
                :tableData="scope.row"
                :btnList="[
                  {
                    permpisions: '1100102',
                    showCondition: !scope.row.isAdmin,
                    name: '修改',
                    event: () => toEdit(scope.row.userId),
                  },
                  {
                    permpisions: '1100103',
                    showCondition: !scope.row.isAdmin,
                    name: '授权',
                    event: () => showSetRolDialog(scope.row),
                  },
                  {
                    permpisions: '1100206',
                    showCondition: !scope.row.isAdmin,
                    name: '解除员工授权',
                    event: () => deleteRoleAuth(scope.row),
                  },
                  {
                    permpisions: '1100105',
                    showCondition: !scope.row.isAdmin,
                    name: '删除',
                    event: () => del(scope.row.userId),
                  },
                  {
                    showCondition: true,
                    name: '日志',
                    event: () => showLog(scope.row.userId),
                  },
                ]"
              />
            </template>
          </el-table-column>
          <!-- 操按钮 end -->
        </el-table>
      </section>
      <!-- 表格 end -->
      <!-- 分页 -->
      <section class="paginationBox clearPa">
        <!-- 分页组件 -->
        <section class="right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.page"
            :page-sizes="[10, 20, 50]"
            :page-size="tableData.count"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.total"
          ></el-pagination>
        </section>
        <!-- 分页组件 end -->
      </section>
      <!-- 分页 end -->
    </section>
  </qx-card>
</template>

<script>
import ChooseRole from 'components/chooseRole/chooseRole';
import LogRightDialog from 'components/logRightDialog';
import tableMixin from '@qx/mixin/table';
import TableBtn from 'components/tableBtn/tableBtn';
import TableSetting from 'components/tableSetting/tableSetting';
import {
  userList,
  userDel,
  userSetRole,
  delRelationRoleAndUser,
} from 'api/system';
export default {
  mixins: [
    tableMixin,
  ],
  components: {
    ChooseRole,
    LogRightDialog,
    TableBtn,
    TableSetting,
  },
  data () {
    return {
      editItem: {},
      tableData: { // 表格相关数据
        loading: false,
        count: 10,
        page: 1,
        total: 0,
        selectResult: [], // 表格选中的结果
        title: [ // 表头
          { prop: 'loginAcct', label: '登录手机', fixed: true },
          { prop: 'linkman', label: '员工姓名' },
          { prop: 'orgNames', label: '所属部门' },
          { prop: 'staffNickname', label: '账号名称' },
          { prop: 'employeeNumber', label: '员工工号' },
          { prop: 'staffPosition', label: '员工职位' },
          { prop: 'employeeAttributesName', label: '员工属性'},
          { prop: 'roleNames', label: '拥有权限' },
          { prop: 'lockFlagName', label: '账号状态' },
          { prop: 'bankBindStateName', label: '银行卡' },
        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  methods: {
    getList: userList,
    showSetRolDialog (item) {
      this.editItem = item;
      this.$refs.chooseRole.show(item);
    },
    async handleRoleChange (item) {
      this.tableData.loading = true;
      let roleIds = item.map((item) => item.roleId);
      roleIds = roleIds.join(',');
      const res = await userSetRole({
        roleIds,
        userId: this.editItem.userId,
      });
      if (!res.failed) {
        this.$message.success('授权成功');
        await this.getData();
      }
      this.tableData.loading = false;
    },
    async del (userId) {
      const confirmRes = await this.$confirm('是否确认删除', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).catch(() => { // 取消删除
        this.$message({
          type: 'info',
          message: '已取消删除',
        });
      });
      if (confirmRes === 'confirm') {
        const res = await userDel({
          userId,
        });
        if (!res.failed) {
          this.$message.success('删除成功');
          this.getData();
        }
      }
    },
    async deleteRoleAuth (item) {
      const confirmRes = await this.$confirm(`确定将员工【${item.linkman}】拥有的角色【${item.roleNames}】移除？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).catch(() => { // 取消删除
        this.$message({
          type: 'info',
          message: '已取消操作',
        });
      });
      if (confirmRes === 'confirm') {
        const res = await delRelationRoleAndUser({
          operatorIds: item.operatorId,
          roleIds: this.$route.query.roleId || item.roleIds,
        });
        if (!res.failed) {
          this.$message.success('解除员工授权成功');
          this.getData();
        }
      }
    },
    showLog (id) {
      this.$refs.logRightDialog.show(id);
    },
    toBankcard (item) {
      this.jump({
        label: '银行卡信息',
        url: `/manage/other/bankcard?userId=${item.userId}&linkman=${encodeURIComponent(item.linkman)}&idNum=${item.identification}&worker=true`,
        full: true,
      });
    },
    toDetail (item, type = '') {
      this.jump({
        label: type ? '审核员工' : '员工详情',
        url: `/manage/system/jurisdiction/worker/detail?id=${item.userId}&type=${type}`,
      });
    },
    toEdit (id) {
      this.jump({
        label: (id ? '修改' : '新增') + '员工',
        url: `/manage/system/jurisdiction/worker/edit${id ? '?id=' + id : ''}`,
        full: true,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.control {
  span {
    margin-right: 16px;
  }
}
</style>
